"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EngineEvent = void 0;
var EngineEvent;
(function (EngineEvent) {
    EngineEvent["WalletScanComplete"] = "scanned";
    EngineEvent["ContractNullifierReceived"] = "nullified";
    EngineEvent["MerkletreeHistoryScanStarted"] = "merkletree-history-scan-started";
    EngineEvent["MerkletreeHistoryScanUpdate"] = "merkletree-history-scan-update";
    EngineEvent["MerkletreeHistoryScanComplete"] = "merkletree-history-scan-complete";
    EngineEvent["MerkletreeHistoryScanIncomplete"] = "merkletree-history-scan-incomplete";
})(EngineEvent = exports.EngineEvent || (exports.EngineEvent = {}));
